const getWebsiteBaseUrl = () => {
    return process.env.REACT_APP_EQUINE_URL || 'https://www.equine.gg'; // TODO implement proper way with multiple possible environments (test, prod)
};
export const BASE_WEB_URL = getWebsiteBaseUrl();
export var Routes;
(function (Routes) {
    Routes["HOME"] = "/";
    Routes["LOGIN"] = "/login";
    Routes["SIGN_UP"] = "/sign_up";
    Routes["RACE"] = "/race";
    Routes["STABLES_LIST"] = "/stables/race/list";
    Routes["STABLES_LIST_STAKE_ID"] = "/stables/:stakeId/race/list";
    Routes["STABLES_LIST_HORSES"] = "/stables/race/list/horses";
    Routes["STABLES_LIST_HORSES_STAKE_ID"] = "/stables/:stakeId/race/list/horses";
    Routes["STABLES_LIST_JOCKEYS"] = "/stables/race/list/jockeys";
    Routes["STABLES_LIST_JOCKEYS_STAKE_ID"] = "/stables/:stakeId/race/list/jockeys";
    Routes["RACE_HORSE_STABLE_ID"] = "/stables/:stakeId/race/horse";
    Routes["RACE_JOCKEY_STABLE_ID"] = "/stables/:stakeId/race/jockey";
    Routes["STABLES"] = "/stables/race";
    Routes["STABLES_STAKE_ID"] = "/stables/:stakeId/race";
    Routes["MARKETPLACE"] = "/marketplace";
    Routes["SOCIAL"] = "social";
    Routes["NEWS"] = "/news/all-news/";
    Routes["FAQ"] = "/faq/getting-started/";
    Routes["WHITEPAPER"] = "/whitepaper/";
    Routes["MY_ACCOUNT"] = "/my_account/about";
    Routes["NOTIFICATIONS"] = "/my_account/notifications";
    Routes["NOT_FOUND"] = "*";
    Routes["CONFIRMATION"] = "/confirmation";
    Routes["BREEDING"] = "/stables/breeding";
    Routes["TRAINING"] = "/stables/training";
    Routes["FRIENDS"] = "friends";
    Routes["MY_GUILD"] = "my-guild";
    Routes["ALL_GUILD"] = "all-guilds";
    Routes["GUILD"] = "/social/guild/:id";
    Routes["RACING_HISTORY"] = "/stables/:stakeId/racing-history";
    Routes["UPCOMING_EVENTS"] = "/race/upcoming-events";
    Routes["RESULTS"] = "/results";
    Routes["WINNINGS"] = "/winnings";
    Routes["LEADERBOARDS"] = "/leaderboards";
    Routes["FORGOTTEN_PASSWORD"] = "/forgotten_password";
    Routes["RESET_PASSWORD"] = "/reset-password";
    Routes["SELL"] = "/sell";
    Routes["BUY"] = "/buy";
    Routes["ACTIVITY"] = "/activity";
    Routes["DISCORD_CALLBACK"] = "/discord/callback";
    Routes["CONFIGURATOR"] = "/stables/race/configurator";
    Routes["CONFIGURATOR_STAKE_ID"] = "/stables/:stakeId/race/configurator";
    Routes["CHAT_LIST"] = "/chat-list";
})(Routes || (Routes = {}));
